import { post, patch, getData } from '@/lib/api';

export const authApi = {
  login: async (credentials) => (await post('/auth/login', credentials)).data,
  logout: () => post('/auth/logout'),
  me: () => getData('/auth/me'),
  /** Name, phone and interface language — everything a person may change about themselves. */
  updateProfile: async (body) => (await patch('/auth/me', body)).data,
  changePassword: async (body) => (await post('/auth/change-password', body)).data,
  forgotPassword: (email) => post('/auth/forgot-password', { email }),
  resetPassword: (body) => post('/auth/reset-password', body),

  /**
   * "Sign out everywhere." Revokes the refresh-token family and bumps `tokenVersion`,
   * so every other device's access token dies at its next request — including this one,
   * which is why the caller signs out locally straight afterwards.
   */
  logoutEverywhere: () => post('/auth/logout-everywhere'),

  startMfa: async () => (await post('/auth/mfa/setup')).data,
  enableMfa: async (body) => (await post('/auth/mfa/enable', body)).data,
  disableMfa: async (body) => (await post('/auth/mfa/disable', body)).data,
};

export default authApi;
